import React from 'react';

export const ErrorTextTW: React.FC<{ errorText?: string }> = ({ errorText }) => {
  if (errorText === undefined) {
    return null;
  }
  return (
    <p className="text-xs text-text-error" role={'paragraph'}>
      {errorText}
    </p>
  );
};
